import { NavTab } from '@/components/layouts/BicesterToolbar';
import { MENU } from '@/constants/menu'

export enum MAKE_SERVICE {
  /**
   * 预约管理
   */
  MANAGE = 'manage',

  /**
   * 代客预约
   */
  REPLACE_MAKE = 'replace-make',

  /**
   * 免提购物核销
   */
  SHOPING = 'shopping',

  /**
   * 导购大使核销
   */
  SA = 'sa',

  /**
   * 贵宾休息室核销
   */
  LOUNGE = 'lounge',

  /**
   * 代客泊车核销
   */
  PARKING = 'parking',

  /**
   * 服务记录
   */
  LOG = 'log',

  /**
   * 服务余量设置
   */
  MARGIN = 'margin',

  /**
   * 实际余量查询
   */
  MARGIN_QUERY = 'margin-query'
}

export enum SERVICE_LOG_DETAIL {
  /**
   * 服务记录查询
   */
  LIST = 'list',

  /**
   * 免提购物
   */
  SHOPING = 'shopping',

  /**
   * 代客泊车
   */
  PARKING = 'parking',

  /**
   * 导购大使
   */
  SA = 'sa',

  /**
   * 贵宾休息室
   */
  LOUNGE = 'lounge',
}

export enum SUBSCRIBE_OPTION {
  /**
   * 导购大使
   */
  SA = 175,
  /**
   * 贵宾休息室
   */
  LOUNGE = 101,
  /**
   * 代客泊车
   */
  PARKING = 7,
  /**
   * 免提购物
   */
  SHOPPING = 2,
  /**
   * 婴儿推车
   */
  BABY = 5,
  /**
   * 宠物推车
   */
  PET = 3,
  /**
   * 轮椅
   */
  WHEELCHAIR = 126,
}

export const MAKE_SERVICE_MAP = {
  [MAKE_SERVICE.MANAGE]: '预约管理',
  [MAKE_SERVICE.REPLACE_MAKE]: '代客预约',
  [MAKE_SERVICE.SHOPING]: '免提购物核销',
  [MAKE_SERVICE.SA]: '导购大使核销',
  [MAKE_SERVICE.LOUNGE]: '贵宾休息室核销',
  [MAKE_SERVICE.PARKING]: '代客泊车核销',
  [MAKE_SERVICE.LOG]: '服务记录',
  [MAKE_SERVICE.MARGIN]: '服务余量设置',
  [MAKE_SERVICE.MARGIN_QUERY]: '实际余量查询',
}

export const SERVICE_LOG_DETAIL_MAP = {
  [SERVICE_LOG_DETAIL.LIST]: '服务记录查询',
  [SERVICE_LOG_DETAIL.SHOPING]: '免提购物详情',
  [SERVICE_LOG_DETAIL.PARKING]: '代客泊车详情',
  [SERVICE_LOG_DETAIL.SA]: '导购大使详情',
  [SERVICE_LOG_DETAIL.LOUNGE]: '贵宾休息室详情',
}

export const pageTabs: NavTab[] = Object.keys(MAKE_SERVICE).map(key => ({
  label: MAKE_SERVICE_MAP[MAKE_SERVICE[key]],
  key: MAKE_SERVICE[key],
  url: getPath(MAKE_SERVICE[key])
}))

export function getPath(key: MAKE_SERVICE) {
  return `/${MENU.SUBSCRIBE_SERVICE}/${key}`
}

export function getDetailPath(key: SERVICE_LOG_DETAIL) {
  return `/${MENU.SUBSCRIBE_SERVICE}/${MAKE_SERVICE.LOG}/${key}`
}
